var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message.text)?_c('div',{class:_vm.messageClass},[_c('span',[_vm._v(_vm._s(_vm.message.text))]),_c('span',{staticClass:"messages__timestamp"},[_vm._v(_vm._s(_vm.timeStamp))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }